import { useGetPerformanceGraphQuery, useGetPerformanceReportQuery } from "api/TenantSlug/Report/hooks.ts";
import { TimeGraph } from "components/Graph/UI/TimeGraph/TimeGraph.tsx";
import { GeneralGraphUtils } from "components/Graph/utils/GeneralGraphUtils.ts";
import { ALLOWED_KEYS, DEFAULT_VISIBLE_KEYS } from "components/Report/common-config.ts";
import { useCreatedAtFilterValue } from "components/UI/Table/utils/getDefaultCreatedAtFilter";
import dayjs, { Dayjs } from "dayjs";
import { useUser } from "hooks/useUser.ts";
import { DATE_FORMAT_WITH_TIME } from "localConstants";
import { useMemo, useState } from "react";
import { PayoutResult, PerformanceReportDataSourceEnum, PerformanceReportViewEnum } from "types/enums.ts";
export const DashboardPerformanceReport = () => {
    const userUtils = useUser();
    const createdAtStr = useCreatedAtFilterValue();

    const [actualStatuses] = useState<PayoutResult[]>([PayoutResult.Approved]);
    const [dateRange] = useState<[Dayjs | null, Dayjs | null]>(() => {
        if (!createdAtStr || !createdAtStr.includes(",")) return [null, null];
        const [a, b] = createdAtStr.split(",");
        return [dayjs(a), dayjs(b)];
    });


    const effectiveDatetimeAt = useMemo(() => {
        const [start, end] = dateRange;
        if (start && end) {
            return {
                btw: `${start.startOf("day").format(DATE_FORMAT_WITH_TIME)},${end
                    .endOf("day")
                    .format(DATE_FORMAT_WITH_TIME)}`,
            };

        }
        return { btw: createdAtStr };
    }, [dateRange, createdAtStr]);

    const isAdmin = userUtils.isAdmin();

    const { data, isLoading, isError } = useGetPerformanceGraphQuery({
        filter: {
            filter: {
                payout_result: { in: actualStatuses },
                datetime_at: effectiveDatetimeAt,
            },
            sort: "-datetime_at",
        },
        view: isAdmin ? PerformanceReportViewEnum.TenantAdmin : PerformanceReportViewEnum.AffiliatePartner,
        source: PerformanceReportDataSourceEnum.ReportPayoutPerformances,
    });

    const { data: reportData } = useGetPerformanceReportQuery({
        page: { number: 1, size: 1 },
        filter: {
            filter: {
                payout_result: { in: actualStatuses },
                datetime_at: effectiveDatetimeAt,
            },
            sort: "-datetime_at",
        },
        view: isAdmin ? PerformanceReportViewEnum.TenantAdmin : PerformanceReportViewEnum.AffiliatePartner,
        source: PerformanceReportDataSourceEnum.ReportPayoutPerformances,
    });

    return (
        <>
            <TimeGraph
                data={GeneralGraphUtils.prepareTimeData(data?.timeline || {})}
                keys={ALLOWED_KEYS(isAdmin)}
                defaultActiveKeys={DEFAULT_VISIBLE_KEYS(isAdmin)}
                defaultVisibleKeys={DEFAULT_VISIBLE_KEYS(isAdmin)}
                graphId={"dashboard-performance-graph"}
                loading={isLoading}
                error={isError}
                summaryData={reportData?.summary}
            />
        </>
    );
};
